
  export default {
    props: {
      isOpen: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: '',
      },
      titleIcon: {
        type: [String, Object],
        default: null,
      },
      subTitle: {
        type: String,
        default: '',
      },
      text: {
        type: String,
        default: '',
      },
      modalWidth: {
        type: String,
        default: 'fit-content',
      },
      // false — модалку нельзя закрыть (нет крестика, клик по overlay игнорируется)
      closable: {
        type: Boolean,
        default: true,
      },
      // на мобилке по центру (как старые .modal), а не bottom-sheet
      mobileCentered: {
        type: Boolean,
        default: false,
      },
    },

    emits: ['update:is-open'],

    data() {
      return {
        isMouseDownOnOverlay: false, // Флаг: нажатие было на overlay
      }
    },

    watch: {
      isOpen: {
        handler(newVal) {
          if (newVal) {
            this.lockScrollBar()
          } else {
            this.unlockScrollBar()
          }
        },
        immediate: true, // Вызывается сразу при монтировании
      },
    },

    mounted() {},

    methods: {
      closeModal() {
        this.$emit('update:is-open', false)
      },

      // Обработчик нажатия на overlay
      handleOverlayMouseDown(event) {
        // Проверяем, что клик был именно по overlay (не по дочерним элементам)
        if (event.target === event.currentTarget) {
          this.isMouseDownOnOverlay = true
        } else {
          this.isMouseDownOnOverlay = false
        }
      },

      // Обработчик отпускания на overlay
      handleOverlayMouseUp(event) {
        // Проверяем, что нажатие было на overlay и отпускание тоже на overlay
        if (
          this.closable &&
          this.isMouseDownOnOverlay &&
          event.target === event.currentTarget
        ) {
          this.closeModal()
        }

        // Сбрасываем флаг
        this.isMouseDownOnOverlay = false
      },

      // Блокировка скролла
      lockScrollBar() {
        // Сохраняем ширину скроллбара для предотвращения скачка контента
        const scrollbarWidth =
          window.innerWidth - document.documentElement.clientWidth

        // Добавляем класс на body
        document.body.style.overflow = 'hidden'

        // Компенсируем смещение из-за скрытия скроллбара
        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = `${scrollbarWidth}px`
        }
      },

      // Разблокировка скролла
      unlockScrollBar() {
        // Убираем стили
        document.body.style.overflow = ''
        document.body.style.paddingRight = ''
      },
    },
  }
